<template>
  <div>
    <cv-navbar/>
    <div class="accountUsers clearfix">
      <leftPanel :currentIndex='1'></leftPanel>
      <div class="right-modal fr">

        <div class="item-modal bind-data bg_fff">
          <div class="item-title"><span class="color_40 f_22">账号设置</span></div>

          <div class="item-list flex-c">
            <div class="title f_14 color_40">微信</div>
            <div class="flex1 f_14 clearfix">
              <template v-if="bindData.wechat_is_bound">
                <div class="value-model fl color_40">已绑定</div>
                <div class="color_red fl cursor_p" @click="unbindAccount('wechat')">解绑</div>
              </template>
              <template v-else>
                <div class="value-model fl color_9c">未绑定</div>
                <div class="color_red fl cursor_p" @click="getQrcode">绑定</div>
              </template>
            </div>
          </div>
          <div class="item-list flex-c">
            <div class="title f_14 color_40">绑定手机</div>
            <div class="flex1 f_14 clearfix">
              <template v-if="bindData.phone && bindData.phone_is_bound">
                <div class="value-model fl color_40">{{bindData.phone}}</div>
                <div class="color_red fl cursor_p" @click="unbindAccount('phone')">解绑</div>
              </template>
              <template v-else>
                <div class="value-model fl color_9c">未绑定</div>
                <div class="color_red fl cursor_p" @click="bindAccount('phone')">绑定</div>
              </template>
            </div>
          </div>
          <!-- <div class="item-list flex-c" v-if="bindData.user.email">
            <div class="title f_14 color_40">绑定邮箱</div>
            <div class="flex1 f_14 clearfix">
              <div class="value-model fl color_40">{{bindData.user.email}}</div>
            </div>
          </div> -->
        </div>

      </div>
    </div>
    <!-- 绑定邮箱/手机号/弹层 -->
    <div class="bindTips" v-if="bindTipsOptions.state" @click="cancelForm()">
      <div class="tipsContent pa bg_fff" @click.stop>
        <div class="tipsTitle f_18 color_40 font_w_b">{{bindTipsOptions.type==='phone'?'绑定手机号':'绑定邮箱'}}</div>

        <template v-if="bindTipsOptions.type==='phone'">
          <div class="form">
            <dl class="formItem flex" :class="[bindTipsError.phone?'errorTips':'']">
              <dt class="f_14 color_60"><span>手机号码</span>：</dt>
              <dd class="flex1">
                <div class="phoneBox flex-c">
                  <div class="phoneType text_center f_14 color_60">+86</div>
                  <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone" placeholder="请输入你的手机号" @focus="inputFocus('phone')" :maxlength="11" ></el-input>
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="bindTipsError.phone">
                  <span class="iconfont iconinfo"></span>
                  <span class="tipsName">{{bindTipsError.phone}}</span>
                </div>
              </dd>
            </dl>
            <dl class="formItem flex" :class="[bindTipsError.code?'errorTips':'']">
              <dt class="f_14 color_60"><span>验证码</span>：</dt>
              <dd class="flex1">
                <div class="codeBox flex-c">
                  <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone_token" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
                  <div class="time cursor_p text_center f_14">
                    <span class="color_blue" @click="checkCode('phone')" v-if="bindTipsOptions.time === 60">发送验证码</span>
                    <span class="color_90" v-else >{{bindTipsOptions.time}}s</span>
                  </div>
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="bindTipsError.code">
                  <span class="iconfont iconinfo"></span>
                  <span class="tipsName">{{bindTipsError.code}}</span>
                </div>
              </dd>
            </dl>
          </div>
        </template>
        <template v-else-if="bindTipsOptions.type==='email'">
          <div class="form">
            <dl class="formItem flex" :class="[bindTipsError.email?'errorTips':'']">
              <dt class="f_14 color_60"><span>邮箱地址</span>：</dt>
              <dd class="flex1">
                <div class="phoneBox">
                  <el-input class="restInput noBorder f_14 color_40" v-model="bindTipsData.email" placeholder="请输入你的邮箱地址" @focus="inputFocus('email')" :maxlength="30" ></el-input>
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="bindTipsError.email">
                  <span class="iconfont iconinfo"></span>
                  <span class="tipsName">{{bindTipsError.email}}</span>
                </div>
              </dd>
            </dl>
            <dl class="formItem flex" :class="[bindTipsError.code?'errorTips':'']">
              <dt class="f_14 color_60"><span>验证码</span>：</dt>
              <dd class="flex1">
                <div class="codeBox flex-c">
                  <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.email_token" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
                  <div class="time cursor_p text_center f_14">
                    <span class="color_blue" @click="checkCode('email')" v-if="bindTipsOptions.time === 60">发送验证码</span>
                    <span class="color_90" v-else >{{bindTipsOptions.time}}s</span>
                  </div>
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="bindTipsError.code">
                  <span class="iconfont iconinfo"></span>
                  <span class="tipsName">{{bindTipsError.code}}</span>
                </div>
              </dd>
            </dl>
          </div>
        </template>

        <div class="formButtons clearfix">
          <div class="fr confirm text_center bg_red color_fff f_14 cursor_p" @click="updateInfo()">确定</div>
          <div class="fr cancel text_center color_60 f_14 cursor_p" @click="cancelForm()">取消</div>
        </div>
      </div>
    </div>

    <!-- 绑定微信 -->
    <div class="bindQrCode" v-if="showQrCode" @click="hideBindQrcode">
      <div class="tipsContent pa bg_fff text_center" @click.stop>
        <div class="title color_40 f_24">绑定微信，写简历更方便</div>
        <div class="text f_16 color_9c">微信登录，随时编辑，投递简历</div>
        <div class="qrCode pr">
          <img :src="qrCodeData.url" alt="" class="qrCodeImg">
          <img src="https://files.wondercv.com/auth/qrcode_reload.png" alt="" class="qrCodeReload pa cursor_p" @click="getQrcode()" v-if="qrCodeData.checkSize<1">
        </div>
        <div class="text f_16 color_9c">微信扫码 关注超级简历</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { uuid } from 'vue-uuid';
  // 左侧菜单
  import leftPanel from './components/leftPanel';

  import cvNavbar from '@/components/base/navbar';

  import api from '@/api';
  import { mapGetters, mapActions } from 'vuex'
  import { auth, routerTo, get_tUser } from '@/assets/js/util';
  import { updateJWT } from '@/assets/js/jwt'

  export default {
    name: 'accountSettings',
    data () {
      return {
        bindData:{
          phone: "",
          phone_is_bound: false,
          wechat_is_bound: false
        },
        editUserInfoState:false, //可编辑用户基本信息
        getUserInfoState:true,//获取用户基本信息的状态

        requestState:false,//接口请求的状态

        showUploadState:false, //上传图片

        timeName:null, //邮箱倒计时
        bindTipsOptions:{
          state:false, //是否显示弹窗
          time:60, //倒计时
          type:'phone', //编辑类型
          getCodeState:false, //是否正在获取验证码
        },
        bindTipsError:{ //弹窗错误提示
          phone:'',
          phone_token:'',
          email:'',
          email_token:'',
        },
        bindTipsData:{ //绑定手机号参数
          phone:'',
          phone_token:'',
          email:'',
          email_token:'',
        },

        showQrCode:false,//是否显示二维码弹窗
        qrCodeQuery:{ // 获取二维码参数
          scene_str:'bind_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
          account_type:'cv_account', //账户种类 hr_account 或 cv_account
          operation_type:'bind', //是	bind/login 目前只用bind逻辑
          expire_seconds:60, //二维码有效期
        },
        qrCodeData:{ //二维码参数
          url:'',
          checkSize:57/3, // 轮训次数
        },
        qrCodeTimeoutName:null, // 微信登录轮训定时器

      }
    },
    watch: {},
    components:{
      leftPanel,
      cvNavbar
    },
    computed: {},
    created(){
      // console.log(process.env.AUTH_ROOT,"=====>root")
      //检查是否登录
      auth((info)=>{
        if(!info.Authorization){
          //未登录
          routerTo('/signin?type=login')
          return false;
        }
        //获取用户绑定信息
        this.getUsersInfo();
      })
    },
    methods: {
      //获取用户绑定信息
      async getUsersInfo(){
        let user_token = get_tUser().t || '';
        let res = await api.auth.get_users_bind_info(user_token)
        if(res.code === 1000){
          this.bindData = res.data;
        }
      },
      //解绑
      unbindAccount(type){
        let { phone_is_bound, wechat_is_bound } = this.bindData;
        let bindLength = 0; //绑定的长度
        if(wechat_is_bound){
          bindLength+=1
        }
        if(phone_is_bound){
          bindLength+=1
        }
        //绑定方式小于一种不允许解绑
        if(bindLength<2){
          this.$message.error({message: '唯一登录方式，不可解绑'});
          return false;
        }
        if(type==='wechat'){
          //解绑微信
          this.unbindAccountUser('unbind_wechat');
        }else if(type==='phone'){
          //解绑手机号
          this.unbindAccountUser('unbind_phone');
        }else if(type==='email'){
          this.$message.error({message: '邮箱不支持解绑'});
          return false;
        }
      },
      //解绑微信/手机号
      async unbindAccountUser(operation_type){
        if(this.requestState){
          return false;
        }
        let query = {
          account_type: 'cv_account',
          operation_type,
        };
        this.$confirm('确定解绑吗?', '提示', {
          confirmButtonText: '确定',
          confirmButtonClass:'color_red',
          cancelButtonText: '取消',
          cancelButtonClass:'color_60',
          type: 'warning'
        }).then(() => {
          this.requestState = true;
 
          let user_token = get_tUser().t || '';
          api.auth.update_users_bind_info(query, user_token).then(res=>{
            this.requestState = false;
            if(res.code === 1000){
              this.$message({
                message: `解绑成功`,
                type: 'success'
              });
              this.getUsersInfo();
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          })
        }).catch(() => {

        });

      },
      //点击绑定弹窗
      bindAccount(type){
        this.bindTipsOptions.state = true;
        this.bindTipsOptions.type = type;
        if(type === 'phone'){

        }else if(type === 'email'){
          // let { user} = this.bindData;
          // this.bindTipsData.email = user.email || '';

        }
      },

      //【bindTips】取消编辑
      cancelForm(){
        let { type } = this.bindTipsOptions;
        this.bindTipsOptions.state = false;
        clearInterval(this.timeName);
        this.bindTipsOptions.time = 60;
        this.bindTipsOptions.getCodeState = false;
        this.bindTipsError.code = '';

        //改变状态，还原备份数据
        if(type === 'phone'){
          this.bindTipsData.phone = '';
          this.bindTipsData.phone_token = '';
          this.bindTipsError.phone = '';
        }else if(type === 'email'){
          this.bindTipsData.email = '';
          this.bindTipsData.email_token = '';
          this.bindTipsError.email = '';
        }

      },
      //【bindTips】获取验证码 手机号/邮箱
      checkCode(codeType){
        this.bindTipsOptions.type = codeType;
        let { time, state, type, getCodeState, } = this.bindTipsOptions;
        let { phone, phone_token, email, email_token } = this.bindTipsData; //绑定手机号参数
        if(getCodeState){
          return false;
        }
        if(codeType === 'phone'){
          let formState = true;
          if(!phone){
            this.bindTipsError.phone = '请输入手机号';
            formState = false;
          }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
            this.bindTipsError.phone = '请输入正确的手机号';
            formState = false;
          }
          if(!formState){
            return false;
          }
          
          this.getCode();

        }else if(codeType === 'email'){
          // //对电子邮件的验证
          var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
          if(!myreg.test(email)){
            this.bindTipsError.email = '请填写有效的公司邮箱';
            return false;
          }
          this.bindTipsData.getCodeState = true;
          // let query = {
          //   email,
          //   way:'email',
          //   confirm:'yes',
          // }
          // api.account.getValidateCode(query).then(res=>{
          //   if(res.status === 1){
          //     this.$message({
          //       message: '获取验证码成功',
          //       type: 'success'
          //     });
          //     this.bindTipsOptions.time = 59;
          //     this.codeTime();
          //   }else{
          //     this.bindTipsData.getCodeState = false;
          //     this.$message({
          //       message: res.message,
          //       type: 'error'
          //     });
          //   }
          // })
        }


      },
      //【手机】获取短信验证码-接口
      getCode(){
        let codeType = this.bindTipsOptions.type;
        let { time, state, type, getCodeState, } = this.bindTipsOptions;
        let { phone, phone_token, email, email_token } = this.bindTipsData; //绑定手机号参数
        if(getCodeState){
          return false;
        }
        if(codeType === 'phone'){
          this.bindTipsData.getCodeState = true;
            let query = {
              phone_number:phone,
              premise:'cv_account_bind',
              new_code:true
            }
            api.auth.getPhoneCode(query).then(res=>{
              if(res.code === 1000){
                this.$message({
                  message: '获取验证码成功',
                  type: 'success'
                });
                this.bindTipsOptions.time = 59;
                this.codeTime();
              }else{
                this.bindTipsData.getCodeState = false;
                this.$message({
                  message: res.message,
                  type: 'error'
                });
              }
            })
        }
      },

      // 绑定用户信息前的验证 手机号/邮箱
      async updateInfo(){
        let { time, state, type, getCodeState, } = this.bindTipsOptions;
        let { phone, phone_token, email, email_token } = this.bindTipsData; //绑定手机号参数
        let bindSuccessText = '';
        let query = {};
        if(type === 'phone'){
          let formState = true;
          bindSuccessText = '手机号绑定成功';
          if(!phone){
            this.bindTipsError.phone = '请输入手机号';
            formState = false;
          }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
            this.bindTipsError.phone = '请输入正确的手机号';
            formState = false;
          }
          if(!phone_token || phone_token.length<6){
            this.bindTipsError.code = '请输入正确的验证码';
            formState = false;
          }
          if(!formState){
            return false;
          }
          query = {
            operation_type:'bind_phone',
            phone_number:phone,
            phone_code:phone_token
          };
          //绑定手机号
          this.updatePhone(query);
        }else if(type === 'email'){
          let formState = true;
          // //对电子邮件的验证
          var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
          if(!myreg.test(email) || !email.length){
            this.bindTipsError.email = '请填写有效的公司邮箱';
            formState = false;
          }
          if(!email_token || email_token.length<6){
            this.bindTipsError.code = '请输入正确的验证码';
            formState = false;
          }
          if(!formState){
            return false;
          }
          query = { email, email_token };
          this.updateEmail();
        }

      },
      //绑定手机号
      updatePhone(query){
        let user_token = get_tUser().t || '';
        api.auth.update_users_bind_info(query, user_token).then(res=>{
          if(res.code === 1000){
            this.$message({
              message: '手机号绑定成功',
              type: 'success'
            });
            if (res.data && res.data.jwt) {
              updateJWT({
                jwt: res.data.jwt,
                jwt_timestamp: res.data.jwt_timestamp
              })
            }
            //取消弹窗
            this.cancelForm();
            //重新获取用户绑定信息
            this.getUsersInfo();
          }else{
            this.bindTipsData.getCodeState = false;
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      },
      //绑定邮箱
      // updateEmail(query){
      //   api.account.updateInfo(query).then(res=>{
      //     if(res.status === 1){
      //       this.$message({
      //         message: '邮箱绑定成功',
      //         type: 'success'
      //       });
      //       //取消弹窗
      //       this.cancelForm();
      //       //重新获取用户绑定信息
      //       this.getUsersInfo();
      //     }else{
      //       this.bindTipsData.getCodeState = false;
      //       this.$message({
      //         message: res.message,
      //         type: 'error'
      //       });
      //     }
      //   })
      // },
      //【邮箱】倒计时
      codeTime(){
        this.timeName = setInterval(() => {
          if(this.bindTipsOptions.time == 1){
            clearInterval(this.timeName);
            this.bindTipsOptions.time = 60;
            this.bindTipsOptions.getCodeState = false;
            return false;
          }
          this.bindTipsOptions.time = this.bindTipsOptions.time-1;

        }, 1000);
      },
      //【bindTips】取消错误提示
      inputFocus(type){
        this.bindTipsError[type] = '';
      },

      //【微信】获取二维码

      getQrcode(){
        //轮训倒计时
        this.qrCodeData.checkSize = 57/3;
        this.showQrCode = true;
        //清除定时器
        clearInterval(this.qrCodeTimeoutName);

        //获取二维码接口
        api.auth.getWechatsQrcode(this.qrCodeQuery).then(res=>{
          if(res.code === 1000){
            this.qrCodeData.url = res.data.url;
            //轮训倒计时
            this.qrCodeData.checkSize = 57/3;
            // 【微信】检测是否登录
            this.checkWechatLogin();
          }else{
            this.$message.error(res.message);
          }
        })

      },
      //【微信】检测是否扫码
      checkWechatLogin(){
        this.qrCodeTimeoutName = setInterval(() => {
          this.getWechatJwtverify();
          this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
          if(this.qrCodeData.checkSize<1){
            clearInterval(this.qrCodeTimeoutName);
          }
        }, 3000);
      },
      //【微信】验证是否扫码
      getWechatJwtverify(){
        let query = {
          scene_str: this.qrCodeQuery.scene_str,
          operation_type:'bind',
        }
        api.auth.getWechatsQrcodeResult(query).then(async res=>{
          if(res.code === 1000){
            this.$message({
              message: '微信绑定成功',
              type: 'success'
            });
            //关闭二维码
            this.hideBindQrcode();
            //重新获取用户绑定信息
            this.getUsersInfo();
            //重新设置新的uuid
            this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
          }else if(res.code === 200101){
            //此微信已经绑定别的账户
            this.$message({
              message: res.message,
              type: 'error'
            });
            //关闭二维码
            this.hideBindQrcode();
            //重新设置新的uuid
            this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
          }
        })
      },
      //【微信】关闭二维码
      hideBindQrcode(){
        this.showQrCode = false;
        this.qrCodeData = { //二维码参数
          url:'',
          checkSize:57/3, // 轮训次数
        };
        clearInterval(this.qrCodeTimeoutName);
      },

    }
  }
</script>
<style scoped lang="scss">
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './users.scss'
</style>
